<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="RkmModal"
        title="Detalhamento do agendamento"
    >
        <rkm-row>
            <rkm-col>
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <td><strong>Agendamento:</strong></td>
                            <td>{{ agendamento.agendamentoNumero }}</td>
                        </tr>
                        <tr>
                            <td><strong>Data do agendamento:</strong></td>
                            <td>{{agendamento.data}} às {{agendamento.horaInicial}}</td>
                        </tr>
                        <tr>
                            <td><strong>Agendamento urgente:</strong></td>
                            <td>{{ agendamento.urgente ? 'Sim' : 'Não' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Exame / Grupo:</strong></td>
                            <td> {{agendamento.exameGrupoNome}} </td>
                        </tr>
                        <tr v-if="agendamento.responsavel">
                            <td><strong>Responsável:</strong></td>
                            <td>{{agendamento.responsavel}}</td>
                        </tr>
                        <tr>
                            <td><strong>Médico solicitante:</strong> </td>
                            <td>{{agendamento.medicoNome}}</td>
                        </tr>
                        <tr v-if="agendamento.pacienteSexoId == this.enums.sexo.FEMININO">
                            <td><strong>Data da última menstruação:</strong> </td>
                            <td>{{agendamento.dataMenstruacao}}</td>
                        </tr>
                        <tr v-if="agendamento.pacienteSexoId == this.enums.sexo.FEMININO">
                            <td><strong>Gestante:</strong> </td>
                            <td>
                                <span v-if="agendamento.gestante">Sim</span>
                                <span v-else>Não</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Unidade solicitante:</strong> </td>
                            <td>{{agendamento.unidadeNome}} - {{agendamento.infraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Laboratório:</strong></td>
                            <td>{{agendamento.laboratorioInfraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Local de coleta:</strong></td>
                            <td>{{agendamento.coletaInfraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Uso de medicamento:</strong></td>
                            <td>{{agendamento.medicamentos}}</td>
                        </tr>
                        <tr>
                            <td><strong>Suspeita clínica:</strong></td>
                            <td>{{agendamento.suspeita}}</td>
                        </tr>
                        <tr>
                            <td><strong>Observação:</strong></td>
                            <td>{{agendamento.observacao}}</td>
                        </tr>
                    </tbody>
                </table>
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>
// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'
import diasSemana from '@/enums/exame-laboratorial/diasSemana'

export default {
    data: () => ({
        agendamento: {
            data: null,
            exameId: null,
            exameGrupoNome: '',
            agendamentoNumero: '',
            horaInicial: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            medicoNome: '',
            responsavel: '',
            diasSemana:null,
            semanaId: null,
            unidadeId: null,
            unidadeNome: '',
            observacao: '',
            medicamentos: '',
            suspeita: '',
            incluido: [],
            paciente: null,
            urgente: null,
            dataMenstruacao: null,
            gestante: null,
            coletaInfraestruturaNome: '',
            pacienteIdade: null,
            pacienteNome: '',
            pacienteNomeSocial:  '',
            pacientePreferenciaNomeId: null,
            pacienteProntuario:  '',
        },
        enums: {
            preferenciaNome,
            sexo,
            diasSemana
        },
    }),
    methods: {
        open(agendamento, item) {

            var data = moment(agendamento.data, 'DD/MM/YYYY').toDate()
            var dia = data.getDay() + 1;

            this.agendamento.diasSemana = this.getStringDiaSemana(dia)

            this.agendamento.agendamentoNumero = agendamento.agendamentoNumero
            this.agendamento.unidadeNome = agendamento.unidadeNome
            this.agendamento.infraestruturaNome = agendamento.infraestruturaNome
            this.agendamento.medicoNome = agendamento.medicoNome
            this.agendamento.dataMenstruacao = agendamento.dataMenstruacao
            this.agendamento.gestante = agendamento.gestante
            this.agendamento.responsavel = agendamento.responsavel
            this.agendamento.data = agendamento.data.split("-").reverse().join("/")
            this.agendamento.horaInicial = agendamento.horaInicial
            this.agendamento.medicamentos = agendamento.medicamentos || 'Não informado'
            this.agendamento.suspeita = agendamento.suspeita || 'Não informada'
            this.agendamento.observacao = agendamento.observacao || 'Não informada'
            this.agendamento.coletaInfraestruturaNome = agendamento.coletaInfraestruturaNome
            this.agendamento.exameGrupoNome = item.exameGrupoNome
            this.agendamento.urgente = agendamento.urgente
            this.agendamento.pacienteIdade = agendamento.pacienteIdade
            this.agendamento.pacienteNome = agendamento.pacienteNome
            this.agendamento.pacienteNomeSocial = agendamento.pacienteNomeSocial
            this.agendamento.pacientePreferenciaNomeId = agendamento.pacientePreferenciaNomeId
            this.agendamento.pacienteProntuario = agendamento.pacienteProntuario

            this.agendamento.laboratorioNome = agendamento.laboratorioNome
            this.agendamento.laboratorioInfraestruturaNome = agendamento.laboratorioInfraestruturaNome

            this.$refs.RkmModal.show()
        },
        getStringDiaSemana(dia) {

            if (dia == this.enums.diasSemana.DOMINGO){

               return 'DOMINGO'
            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA){

               return 'SEGUNDA-FEIRA'
            } else if (dia == this.enums.diasSemana.TERCA_FEIRA){

               return 'TERÇA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA){

               return 'QUARTA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA){

               return 'QUINTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA){

               return 'SEXTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SABADO){

               return 'SÁBADO'
            }
        }
    },
}
</script>

